import React from "react"
import Top from "../components/top"
import Footer from "../components/footer"
import Header from "../components/header"
import MenuBar from "../components/menuBar"
import TopContent from "../components/topContent"
import "./index.css"
import WrapTypo from "../components/WrapTypo"
import { Helmet } from "react-helmet"
import styled from "styled-components"
import { Hidden } from "@material-ui/core"
import SpTopContent from "../components/spTopContent"
import "../style/font-style.css"
import Layout from "../components/layout"
import Box from "@material-ui/core/Box"
import AOS from "aos"
import "aos/dist/aos.css"
import { useStaticQuery, graphql, Link } from "gatsby"
import continueURL from "../components/continueURL"

import InstagramCars from "../components/InstagramCard"

const Root = styled.div``
export default function Home() {
  continueURL()
  if (typeof document !== `undefined`) {
    AOS.init({
      initClassName: "aos-init", // class applied after initialization
      animatedClassName: "aos-animate", // class applied on animation
      disableMutationObserver: false, // disables automatic mutations' detections (advanced)
      delay: 600, // values from 0 to 3000, with step 50ms
      duration: 1000, // values from 0 to 3000, with step 50ms
      easing: "ease", // default easing for AOS animations
      once: false,
      anchorPlacement: "bottom-bottom",
    })
  }
  return (
    <>
      <Helmet>
        <link href="https://fonts.gstatic.com" rel="preconnect" />
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300&display=swap"
          rel="stylesheet"
        />
        <script>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-KD5NWW6');`}
        </script>

        <title>UNFILTER | 公式オンラインストア</title>
        {/* ogp */}
        <meta
          name="description"
          content="UNFILTER（アンフィルター）はお風呂に入れるだけで定期的に集中スキンケアができる美容バスオイルです。33種の美容成分配合のプレミアムオイルがが心と体のフィルターを取り除き、肌にハリとツヤを与えます。"
        />
        <meta property="og:title" content="UNFILTER | 公式オンラインストア" />
        <meta
          property="og:description"
          content="UNFILTER（アンフィルター）はお風呂に入れるだけで定期的に集中スキンケアができる美容バスオイルです。33種の美容成分配合のプレミアムオイルがが心と体のフィルターを取り除き、肌にハリとツヤを与えます。"
        />
        <meta property="og:url" content="https://store.unfilter.co.jp/" />
        {
          <meta
            property="og:image"
            content="https://store.unfilter.co.jp/images/Frame1-ogp1.png"
          />
        }
        <meta
          name="twitter:card"
          content="UNFILTER（アンフィルター）はお風呂に入れるだけで定期的に集中スキンケアができる美容バスオイルです。33種の美容成分配合のプレミアムオイルがが心と体のフィルターを取り除き、肌にハリとツヤを与えます。"
        />
        <meta property="og:type" content="website" />
        <meta name="google" content="notranslate" />
        <meta name="twitter:card" content="summary_large_image" />
        {/* ogp */}
      </Helmet>
      <script>
        {`<!-- Google Tag Manager (noscript) -->
<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KD5NWW6"
height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
<!-- End Google Tag Manager (noscript) -->`}
      </script>
      <Layout>
        <Root>
          <Header />
          <Hidden xsDown>
            <TopContent />
          </Hidden>
          <Hidden smUp>
            <SpTopContent />
          </Hidden>
          <Footer />
        </Root>
      </Layout>
    </>
  )
}
